import supabase from '../supabaseClient';

const FLUSH_INTERVAL_MS = 5000;
const MAX_BATCH_SIZE = 50;

let buffer = [];
let flushTimer = null;
let flushing = false;

const flushLogs = async () => {
  if (flushing || buffer.length === 0) return;
  flushing = true;
  const batch = buffer;
  buffer = [];

  try {
    const { error } = await supabase.from('logs').insert(batch);
    if (error) throw error;
  } catch (error) {
    console.error('Logging failed:', error);
  } finally {
    flushing = false;
    if (buffer.length > 0) scheduleFlush();
  }
};

const scheduleFlush = () => {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushLogs();
  }, FLUSH_INTERVAL_MS);
};

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', flushLogs);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushLogs();
  });
}

export const logEvent = async (eventType, eventMainUser, eventMinorUser = null, eventComment = null, isSend = false) => {
  try {
    buffer.push({
      event_type: eventType,
      event_main_user: eventMainUser,
      event_minor_user: eventMinorUser,
      event_comment: eventComment,
      is_send: isSend,
      created_at: new Date().toISOString()
    });

    if (buffer.length >= MAX_BATCH_SIZE) {
      await flushLogs();
    } else {
      scheduleFlush();
    }

    return true;
  } catch (error) {
    console.error('Logging failed:', error);
    return false;
  }
};

export const getCurrentUserId = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) throw error;
    return user?.email?.split('@')[0] || null;
  } catch (error) {
    console.error('Failed to get user ID:', error);
    return null;
  }
};

export const logEventForCurrentUser = async (eventType, eventMinorUser = null, eventComment = null, isSend = false) => {
  try {
    const userId = await getCurrentUserId();
    if (!userId) {
      console.warn('No user ID for logging');
      return false;
    }
    
    return await logEvent(eventType, userId, eventMinorUser, eventComment, isSend);
  } catch (error) {
    console.error('Failed to log for current user:', error);
    return false;
  }
};